import React, { Fragment, useState } from "react";
import styled from "@emotion/styled";
import { useQuery } from "@apollo/client";
import { Redirect } from "react-router-dom";
import { MainLayout } from "../../components/layout/main-layout";
import { ContentContainer } from "../../components/layout/content-container";
import { Line } from "../../components/common/line";
import { useChatStore } from "../../store/chatStore";
import { usePleaseLoginInfo } from "../../hooks/use-please-login-info";
import { useIsMobile } from "../../hooks/state-checkers/use-is-mobile";
import { showErrorToast } from "../../toast/toast-service";
import { FormattedMessage } from "react-intl";
import {
  GET_TEACHING_DETAIL,
} from "../../apollo-client/queries";
import { TeacherDetailProfile } from "./teacher-detail-profile/teacher-detail-profile";
import { TeacherDetailComments } from "./teacher-detail-comments/teacher-detail-comments";

import { PrimarySpinner } from "../../components/spinner/primary-spinner";

export const TeacherDetailPage = (props) => {
  const { data, loading, error } = useQuery(GET_TEACHING_DETAIL, {
    variables: {
      _id: props.match.params.teachingId,
      course: props.match.params.id,
      isActive: true,
    },
  });

  const isMobile = useIsMobile();
  const { openPleaseLoginInfo, isLoggedIn } = usePleaseLoginInfo();
  const { startNewChat, setIsChatOpen } = useChatStore();

  let course = [];
  if (!loading && data) {
    course = data.courses.courses[0];
  }

  const startTeacherChat = () => {
    if (!isLoggedIn) {
      openPleaseLoginInfo();
      return;
    }

    const chatData = {
      type: "private",
      chatTitle: course.teachings.teachings[0].teacher.username,
      receiverId: course.teachings.teachings[0].teacher._id,
      chatId: null,
      profilePicture: course.teachings.teachings[0].teacher.profilePicture,
      unreadMessagesCount: 0,
      isTeachingRequest: true,
    };

    startNewChat(chatData);
    setIsChatOpen(true);
  };

  const teaching = data && data.courses.courses[0].teachings.teachings[0];

  if (!loading && !teaching) {
    showErrorToast(
      <FormattedMessage id={"teacher.details.error-message.not-found"} />
    );
    return <Redirect to={`/courses/${course._id}/teachers`} />;
  }

  // Additional teacher teachings from detailed query (when available)
  const additionalTeacherTeachings =
    teaching?.teacher?.teachings?.teachings?.filter(
      (t) => t._id !== teaching._id
    ) || [];

  return (
    <MainLayout
      title={course.title}
      university={course.university}
      course={course}
      loading={loading}
      error={error}
      subscriberCount={course.teachings?.subscriberCount}
      props={props}
    >
      <ContentContainer>
        {isMobile && <Line fullWidth={true} />}
        <DetailsContainer>
          {loading && (
            // loading überarbeiten
            <PrimarySpinnerWrapper>
              <PrimarySpinner />
            </PrimarySpinnerWrapper>
          )}
          {!loading && !error && (
            <Fragment>
              <TeacherDetailProfile
                teaching={teaching}
                courseId={course._id}
                courseTitle={course.title}
                handleStartTeacherChat={startTeacherChat}
                additionalTeacherTeachings={additionalTeacherTeachings}
                props={props}
              />
              {isMobile && <Line />}
              <TeacherDetailComments teaching={teaching} />
              <Placeholder />
            </Fragment>
          )}
        </DetailsContainer>
      </ContentContainer>
    </MainLayout>
  );
};

const DetailsContainer = styled.div`
  height: 100%;
  width: ${(props) => props.theme.detailPageWidth};
  min-width: ${(props) => props.theme.detailPageMinWidth};
  min-height: ${(props) => props.theme.detailPageMinHeight};
  margin: 1px auto 0 auto;

  @media only screen and (max-width: ${(props) =>
      props.theme.xsDevicesBreakpoint}) {
    width: 100%;
    min-width: auto;
  }
`;

const PrimarySpinnerWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Simple placeholder component for spacing
const Placeholder = styled.div`
  height: 1px;
`;
